import styled, { css } from 'styled-components'

type OptionsProps = {
  disabled: boolean
  $active: boolean
  $cursor: 'default' | 'pointer'
  $size: 'small' | 'medium' | 'large'
}

export const Option = styled.div<OptionsProps>`
  display: flex;
  align-items: center;
  min-width: 120px;
  cursor: ${({ $cursor }) => $cursor};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: var(--font-line-height-400);
  border-radius: var(--radius-brand);

  &:hover {
    background: var(--bg-secondary);
  }

  ${({ $size }) =>
    $size === 'small' &&
    css`
      min-height: 32px;
      padding: var(--space-100) var(--space-400);
    `}

  ${({ $size }) =>
    $size === 'medium' &&
    css`
      min-height: 40px;
      padding: var(--space-200) var(--space-300);
    `}

  ${({ $size }) =>
    $size === 'large' &&
    css`
      min-height: 64px;
      padding: var(--space-400) var(--space-400);
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      color: var(--text-secondary);
      cursor: default;

      &:hover {
        background: var(--bg-secondary);
      }
    `};

  ${({ $active }) =>
    $active &&
    css`
      background: var(--bg-secondary);
      font-weight: var(--font-weight-medium);
    `};
`

export const LeftIconContainer = styled.div`
  margin-right: var(--space-300);
  color: var(--text-primary);
`

export const RightIconContainer = styled.div`
  margin-left: auto;
  color: var(--text-secondary);
`
